/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable linebreak-style */
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import IntlMessages from "util/IntlMessages";
import logo from "../../assets/images/vibo_logo.svg";

const Footer = () => (
  // <footer className="app-footer bg-dark">
  //   <div className="container">
  //     <div className="row border-white">
  //       <div className="col-lg-3 col-md-6 d-flex flex-column p-4">
  //         <p className="font-weight-bold footer-title">Download Now</p>
  //         <img
  //           src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Available_on_the_App_Store_%28black%29.png/320px-Available_on_the_App_Store_%28black%29.png"
  //           alt="apple app"
  //         />
  //         <img
  //           src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Get_it_on_Google_play.svg/320px-Get_it_on_Google_play.svg.png"
  //           alt="google app"
  //         />
  //       </div>
  //       <div className="col-lg-3 col-md-6 d-flex flex-column justify-content-between p-4 footer-text">
  //         <p className="font-weight-bold footer-title">Company</p>
  //         <ul>
  //           <li>About</li>
  //           <li>List Your Business</li>
  //           <li>ViboVibo Blog</li>
  //           <li>Careers</li>
  //           <li>Support</li>
  //         </ul>
  //       </div>
  //       <div className="col-lg-3 col-md-6 d-flex flex-column justify-content-start p-4 footer-text">
  //         <p className="font-weight-bold footer-title">Discover</p>
  //         <ul>
  //           <li>User Agreement</li>
  //           <li>Privacy Policy</li>
  //           <li>GDPR</li>
  //           <li>Contact</li>
  //         </ul>
  //       </div>
  //       <div className="col-lg-3 col-md-6 pt-4">
  //         <Button className="btn btn-vibo2">List Your Business</Button>
  //       </div>
  //     </div>
  //     <div className="btm-footer">
  //       <p className="font-weight-bold footer-title">Connect with us</p>
  //       <div className="icons-wrapper">
  //         <a className="icon facebook-icon" href="javascript:void(0)">
  //           <i className="zmdi zmdi-facebook" />
  //         </a>

  //         <a className="icon twitter-icon" href="javascript:void(0)">
  //           <i className="zmdi zmdi-twitter" />
  //         </a>

  //         <a className="icon google-icon" href="javascript:void(0)">
  //           <i className="zmdi zmdi-google-plus" />
  //         </a>

  //         <a className="icon linkedin-icon" href="javascript:void(0)">
  //           <i className="zmdi zmdi-linkedin" />
  //         </a>
  //       </div>
  //       <div>
  //         <p>&copy;ViboVibo</p>
  //       </div>
  //     </div>
  //   </div>
  // </footer>
  <footer>
    <div className="row">
      <div className="col-sm-12 col-md-6 text-sm-center text-md-center text-lg-left footer-navigation">
        <h3>
          <a href="#">
            <img src={logo} />
          </a>
        </h3>
        <p className="links footer-links">
          <a href="#">Home</a>

          <strong> · </strong>
          <a
            href="https://app.termly.io/document/privacy-policy/19ba4bee-7967-4150-81a8-357440964acd"
            target="_blank"
          >
            Privacy
          </a>
          <strong> ·&nbsp;</strong>
          <Link to="/contact">Contact</Link>
        </p>
        <p className="company-name">Vibo Vibo © 2019 </p>
      </div>
      <div className="col-md-6 text-sm-center text-md-right footer-about">
        <h4>Download Apps Now</h4>
        <div id="download-apps">
          <a
            href="https://apps.apple.com/us/app/vibovibo/id1477035527"
            target="_blank"
          >
            <img
              className="img-fluid"
              id="download-ios-app"
              // src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Available_on_the_App_Store_%28black%29.png/320px-Available_on_the_App_Store_%28black%29.png"
              src={require("../../assets/images/appStore.svg")}
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.viboviboclient"
            target="_blank"
          >
            <img
              className="img-fluid"
              id="download-android-app"
              // src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Get_it_on_Google_play.svg/320px-Get_it_on_Google_play.svg.png"
              src={require("../../assets/images/playStore.svg")}
            />
          </a>
        </div>
        <div className="social-links social-icons">
          <a href="http://www.facebook.com/vibovibo88">
            <i className="zmdi zmdi-facebook" />
          </a>
          <a href="https://www.instagram.com/vibovibo88">
            <i className="zmdi zmdi-instagram" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);
export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js